import React, { Component } from "react";
import classes from "./Adminlook.module.css";
import Calendar from "../../../components/Calendar/Calendar";
import Loader from "../../../components/Loader/Loader";
import { connect } from "react-redux";
import axios from "axios";
import { addWorkingDay, recordToDataBase } from "../../../funcs/funcs";
import {
  setTotalMasterList,
  phonesSetTotal,
} from "../../../store/actions/actions";
import trash from "../../../pics/trash.svg";
import phone from "../../../pics/phone.svg";
import { dateFinder } from "../../../funcs/funcs";

import { API_URL } from "../../../utils/api";

class Adminlook extends Component {
  state = {
    calendarValue: new Date(),
    masterNumber: 0,
    choosenDay: new Date(),
    informPanel: null,
  };

  async componentDidMount() {
    //получаем данные из БД
    try {
      //скачиваем базу мастеров
      const response = await axios.get(`${API_URL}/masters.json`);

      const data =
        response.data[
          Object.keys(response.data)[Object.keys(response.data).length - 1]
        ];

      //записываем данные в Редакс
      this.props.setTotalMasterList(data);

      //удаляем лишние записи
      for (let i = 0; i < Object.keys(response.data).length - 1; i++) {
        await axios.delete(
          `${API_URL}/masters/${Object.keys(response.data)[i]}.json`
        );
      }

      //скачиваем базу телефонов

      const responsePhone = await axios.get(`${API_URL}/phones.json`);

      //записываем в редакс
      this.props.phonesSetTotal(
        responsePhone.data[
          Object.keys(responsePhone.data)[
            Object.keys(responsePhone.data).length - 1
          ]
        ]
      );

      //удаляем лишние записи
      for (let i = 0; i < Object.keys(responsePhone.data).length - 1; i++) {
        await axios.delete(
          `${API_URL}/phones/${Object.keys(responsePhone.data)[i]}.json`
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  dateChangeHandler = (date) => {
    const choosenDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    //получаем индекс выбранного дня вне зависимости от часового пояса
    const indexDay = dateFinder(
      choosenDay,
      this.props.masterList[this.state.masterNumber][3]
    );

    //проверяем, существует ли данный день в БД
    //если не существует - добавляем
    if (indexDay === -1) {
      //клонируем состояние
      const clone = this.props.masterList.slice();

      addWorkingDay(clone[this.state.masterNumber][3], choosenDay);

      //записываем данные в Редакс
      this.props.setTotalMasterList(clone);
    }

    //console.log("выбранный день ",this.props.masterList[this.state.masterNumber][3][choosenDay]);

    this.setState({
      calendarValue: date,
      choosenDay: Object.keys(
        this.props.masterList[this.state.masterNumber][3]
      )[indexDay],
      informPanel:
        this.props.masterList[this.state.masterNumber][3][
          Object.keys(this.props.masterList[this.state.masterNumber][3])[
            indexDay
          ]
        ],
    });
  };

  //смена мастера
  masterChangeHandler = (e) => {
    e.preventDefault();

    //находим все кнопки мастеров
    const buttons = document.querySelectorAll(".masterChangeInput");

    //сбрасываем все стили
    buttons.forEach((item) => {
      item.style.backgroundColor = "";
    });

    //задаем стиль выбранной кнопке
    e.target.style.backgroundColor = "#f3bf1b";

    //генерируем клик для обновления списка
    //document.querySelector(".react-calendar__tile--active").click();

    //выставляем состояние
    this.setState({
      masterNumber: e.target.name,
      informPanel: null,
    });
  };

  //обработчик удаления записей
  deleteHandler = async (item) => {
    //очищаем ячейку
    this.state.informPanel[item].status = "";
    this.state.informPanel[item].phone = "";
    this.state.informPanel[item].name = "";

    //клонируем состояние
    const clone = this.props.masterList.slice();

    clone[this.state.masterNumber][3][this.state.choosenDay][item].status = "";
    clone[this.state.masterNumber][3][this.state.choosenDay][item].phone = "";
    clone[this.state.masterNumber][3][this.state.choosenDay][item].name = "";

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  //подсчет количества заявок с данного телефона
  phoneCounter = (phone) => {
    let j = 0;
    this.props.phones.forEach((item) => {
      if (item === phone) {
        j++;
      }
    });
    return j;
  };

  vacationOnHandler = (e) => {
    e.preventDefault();

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //console.log(clone[this.state.masterNumber][3][this.state.choosenDay]);

    //создаем массив дня
    const dayTime = Object.keys(
      clone[this.state.masterNumber][3][this.state.choosenDay]
    );

    //заполняем день заглушками
    dayTime.forEach((item) => {
      clone[this.state.masterNumber][3][this.state.choosenDay][item].status =
        "NOT AVAILABLE";
    });

    //добавляем запись об ОТПУСКЕ
    clone[this.state.masterNumber][3][this.state.choosenDay][
      dayTime[0]
    ].vacation = "Vacanza";

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  vacationOffHandler = (e) => {
    e.preventDefault();

    //клонируем состояние
    const clone = this.props.masterList.slice();

    //console.log(clone[this.state.masterNumber][3][this.state.choosenDay]);

    //создаем массив дня
    const dayTime = Object.keys(
      clone[this.state.masterNumber][3][this.state.choosenDay]
    );

    //очищаем день от заглушек
    dayTime.forEach((item) => {
      clone[this.state.masterNumber][3][this.state.choosenDay][item].status =
        "";
    });

    //удаляем запись об ОТПУСКЕ
    clone[this.state.masterNumber][3][this.state.choosenDay][
      dayTime[0]
    ].vacation = "";

    //записываем данные в Редакс
    this.props.setTotalMasterList(clone);

    //записываем в БД
    recordToDataBase(this.props.masterList);
  };

  render() {
    const now = new Date();

    const minDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 30
    );

    const maxDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 30
    );

    const masterButtons = [];

    masterButtons.push(classes.Admin_master_number);
    masterButtons.push("masterChangeInput");

    return (
      <>
        {this.props.masterList.length === 0 ? (
          <Loader />
        ) : (
          <div className={classes.Admin}>
            <h1>Visualizzazione delle prenotazioni</h1>
            <div className={classes.Admin_left}>
              <p>Scegli giorno</p>
              <Calendar
                minDate={minDate}
                maxDate={maxDate}
                value={this.state.calendarValue}
                onChange={this.dateChangeHandler}
              />
              <p>Shegli barbiere</p>
              {this.props.masterList.map((item, index) => {
                if (index === this.state.masterNumber) {
                  return (
                    <input
                      style={{
                        backgroundColor: "#f3bf1b",
                      }}
                      className={masterButtons.join(" ")}
                      key={index}
                      type="button"
                      value={item[0]}
                      name={index}
                      onClick={(e) => this.masterChangeHandler(e)}
                    />
                  );
                } else {
                  return (
                    <input
                      className={masterButtons.join(" ")}
                      key={index}
                      type="button"
                      value={item[0]}
                      name={index}
                      onClick={(e) => this.masterChangeHandler(e)}
                    />
                  );
                }
              })}
            </div>
            <div className={classes.Admin_right}>
              <p>
                Barbiere:{" "}
                <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                  {this.props.masterList[this.state.masterNumber][0]}
                </span>
                {this.state.choosenDay ? (
                  <>
                    <input
                      style={{
                        margin: "0 10px",
                      }}
                      type="button"
                      value="+ Vacanza"
                      onClick={(e) => this.vacationOnHandler(e)}
                    />
                    <input
                      style={{
                        margin: "0 10px",
                      }}
                      type="button"
                      value="- Vacanza"
                      onClick={(e) => this.vacationOffHandler(e)}
                    />
                  </>
                ) : null}
              </p>
              {this.state.informPanel ? (
                <div className={classes.Admin_right_information}>
                  {/* eslint-disable-next-line */}
                  {Object.keys(this.state.informPanel).map((item, index) => {
                    if (this.state.informPanel[item].vacation === "Vacanza") {
                      return (
                        <div>
                          <p
                            style={{
                              textAlign: "center",
                              fontSize: "66px",
                              fontWeight: "bold",
                              color: "#f3bf1b",
                            }}
                          >
                            Vacanza
                          </p>
                        </div>
                      );
                    }
                    if (
                      this.state.informPanel[item].status === "NOT AVAILABLE"
                    ) {
                      return null;
                    } else if (this.state.informPanel[item].status !== "") {
                      return (
                        <div
                          key={index}
                          className={classes.Admin_right_information_panel}
                        >
                          <p
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              margin: "0 20px",
                              minWidth: "60px",
                            }}
                          >
                            {item}
                          </p>
                          <div style={{ width: "75% ", margin: "0 10px" }}>
                            <p>
                              Servizio: {this.state.informPanel[item].status}
                            </p>
                            <hr />
                            <p>Nome: {this.state.informPanel[item].name}</p>
                            <hr />
                            <p>
                              Telefono:
                              <a
                                href={`tel:${this.state.informPanel[item].phone}`}
                              >
                                <span>
                                  {this.state.informPanel[item].phone}
                                </span>
                                <use href="#call" />
                                <img
                                  style={{
                                    width: "20px",
                                    height: "auto",
                                    marginLeft: "5px",
                                  }}
                                  src={phone}
                                  alt="call"
                                />
                              </a>
                              , quantità: [
                              {this.phoneCounter(
                                this.state.informPanel[item].phone
                              )}
                              ]
                            </p>
                          </div>
                          <div style={{ width: "36px" }}>
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => this.deleteHandler(item)}
                              src={trash}
                              alt="delete"
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              ) : (
                <div className={classes.Admin_right_information_empty}></div>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    masterList: state.masterList,
    phones: state.phones,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTotalMasterList: (arr) => dispatch(setTotalMasterList(arr)),
    phonesSetTotal: (arr) => dispatch(phonesSetTotal(arr)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Adminlook);
